/**
 * Locale configuration for both Next.js and Payload CMS
 *
 * This file exports locale constants that are shared between:
 * - next-intl routing (src/i18n/routing.ts)
 * - Payload CMS localization (src/payload/payload.config.ts)
 */

export const locales = ['en-us', 'es-mx'] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'en-us'

/**
 * All locales that should appear in hreflang alternate links.
 * Includes locales served by both Nexus and the legacy site.
 */
export const hreflangLocales = [
    'de-de',
    'en-ca',
    'en-gb',
    'en-us',
    'es-es',
    'es-mx',
    'fr-ca',
    'fr-fr',
    'it-it',
    'nl-nl',
] as const
